import React from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TooltipHost } from 'office-ui-fabric-react';
import styles from './AutosuggestDropdownItem.style';

const AutosuggestDropdownItem = ({
  icon,
  value,
  label,
  href,
  secondaryLabel,
  tertiaryLabel,
  onClick,
  history,
  ...other
}) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick({ value, label, href, other });
    } else if (history && href) {
      history.push(href);
    }
  };

  return (
    <Stack
      key={value}
      className={styles.root}
      horizontal
      wrap
      horizontalAlign="start"
      verticalAlign="center"
      tokens={{ childrenGap: 5 }}
      onClick={handleOnClick}
      onKeyPress={() => history.push(href)}
      tabIndex={0}
      data-testid="autosuggestDropdownItem"
      {...other}
    >
      {icon && (
        <Stack.Item className={styles.iconContainer}>
          <FontIcon iconName={icon} className={styles.icon} />
        </Stack.Item>
      )}

      <Stack.Item className={styles.labelContainer}>
        <Text
          className={styles.label}
          aria-label={label}
          role="link"
          data-testid="autosuggestDropdownItemLabel"
        >
          <TooltipHost content={label}>{label}</TooltipHost>
        </Text>
      </Stack.Item>

      {secondaryLabel && (
        <>
          <Stack.Item className={styles.secondaryLabelContainer}>
            <Text className={styles.description}>{`#${secondaryLabel}`}</Text>
          </Stack.Item>

          {tertiaryLabel && (
            <Stack.Item className={styles.tertiaryLabelContainer}>
              <Text className={styles.description}>{`${tertiaryLabel}`}</Text>
            </Stack.Item>
          )}
        </>
      )}
    </Stack>
  );
};

AutosuggestDropdownItem.propTypes = {
  icon: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  secondaryLabel: PropTypes.string,
  tertiaryLabel: PropTypes.string,
  onClick: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

AutosuggestDropdownItem.defaultProps = {
  icon: null,
  secondaryLabel: null,
  tertiaryLabel: null,
  onClick: null,
};

export default AutosuggestDropdownItem;
